import { useDispatch } from "react-redux";

import { useMutation } from "@tanstack/react-query";

import { apiThatThrows } from "containers/Request";
import { AwsUpload } from "src/hooks/aws/types";
import { ApiResponse } from "types/api";

import { TiVoImage } from "./types";

export const useGenerateImageUpload = () => {
  const dispatch = useDispatch();

  return useMutation<
    ApiResponse<AwsUpload>,
    Error,
    TiVoImage & { mimeType: string }
  >({
    mutationFn: async (queryParams) =>
      dispatch(
        apiThatThrows.generateTiVoImageUpload.action({
          queryParams,
        })
      ),
  });
};
